import React, { Component } from "react";
import Loading from "../../../../../shared/Loading/Loading";
import SalesListHeaderBoxValue from "./SalesListHeaderBoxValue";
import { formatMonthNumberToMonthName } from "../../../../shared/utils";
import { MonthsPTBR } from "../../../../shared/enums";

class SalesListToReceiveHeader extends Component {
	constructor(props) {
		super(props);
		this.props.findUserPayments();
	}

	render() {
		const { payments, isFetching } = this.props.userPayments;
		return (
			<div className="sales-list-header__boxes__content__values__block-of-status-contents">
				<SalesListHeaderBoxValue
					value={payments.toReceive + payments.feeToReceive || 0}
					isFetching={isFetching}
					title={`${MonthsPTBR[payments.thisMonth] || "-"}`}
				/>
				<SalesListHeaderBoxValue
					value={payments.toReceiveNextMonth || 0}
					isFetching={isFetching}
					title={`${MonthsPTBR[payments.thisMonth == 12 ? 1 : payments.thisMonth + 1] || "-"}`}
				/>
				<SalesListHeaderBoxValue
					value={this.props.totalMiles}
					isDecimal={true}
					isFetching={isFetching}
					title="Milhas vendidas:"
				/>
			</div>
		);
	}
}

export default SalesListToReceiveHeader;
